import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ApprovalDropDown = React.forwardRef(({ onActionChange, waste, imageUrl, isOpen, onToggle }, ref) => {
  const options = ['View', 'Approve'];

  const handleOptionClick = (option) => {
    onActionChange(option, imageUrl, waste);
    onToggle();
  };

  return (
    <div className="dropdown" ref={ref}>
      <button onClick={onToggle} className="dropdown-toggle">
        <span> Action </span>
        <KeyboardArrowDownIcon />
      </button>
      {isOpen && (
        <ul className="dropdown-menu" style={{ zIndex: 1000 }}>
          {options.map((option) => (
            <li
              key={option}
              onClick={() => handleOptionClick(option)}
              className="dropdown-item"
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

export default ApprovalDropDown;
